import React from 'react';
import DescriptionListItem from 'components/v2/DescriptionListItem';

export default function OfferPlannerModalHeaderInfo({ data, headerLabel }) {
  return (
    <div className="grid grid-cols-2 gap-4" data-testid={headerLabel}>
      <div className="col-span-2">
        <div className="font-semibold text-lg">{headerLabel}</div>
      </div>
      {data.map(({ label, value }, index) => (
        <DescriptionListItem
          key={index}
          label={label}
          labelClassName="!text-black font-semibold"
        >
          {value}
        </DescriptionListItem>
      ))}
    </div>
  );
}
